import { createContext } from "react";
import type { BlocksContextType } from "schemas";

export const BlocksContext = createContext<BlocksContextType>({
  SelectAppointmentDrawer: () => <div />,
  FormLinkBlockDrawer: () => <div />,
  PageBlockDrawer: () => <div />,
  onPageEdit: (_pageId) => {},
  SocialLinksEditor: () => <div />,
  NewImage: () => <div />,
  EditPopover: () => <div />,
});
